import { render, staticRenderFns } from "./textimg.vue?vue&type=template&id=76451152"
import script from "./textimg.vue?vue&type=script&lang=js"
export * from "./textimg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports